// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EntityForm input,\n.EntityForm textarea {\n    width: 100%;\n}\n.EntityForm textarea {\n    min-height: 150px;\n}\n.EntityForm td.title {\n    width: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
